import Navbar from "../component/common/Arabic/Navbar";
import HomeHero from "../component/home-arabic/HomeHero";
import About from "../component/home-arabic/About";
import TopSubjects from "../component/home-arabic/TopSubjects";
import Training from "../component/home-arabic/Training";
import Team from "../component/home-arabic/Team";
import Footer from "../component/common/Footer";
import styles from "./HomeArabic.module.css";

const HomeArabic = () => {
  return (
    <div>
      <Navbar />
      <div className={styles.container}>
        <HomeHero />
        <About />
        <TopSubjects />
        <Training />
        <Team />
      </div>
      <Footer />
    </div>
  );
};
export default HomeArabic;
